export default __webpack_public_path__ + "static/media/list.a0731a06.svg";